import { useCallback } from 'react';

import { useStarterDashboardPageData } from 'src/app/pages/starterDashboard/pageContext';

import { useShareVisualModal } from './useShareVisualModal';

type Context = 'starter_dashboard_grow_petition';

export function useTriggerShareVisualModal(context: Context): () => Promise<void> {
	const { data } = useStarterDashboardPageData();

	const openShareVisualModal = useShareVisualModal();

	const triggerShareVisualModal = useCallback(async () => {
		return openShareVisualModal({ petition: data.petition, context }).waitForResult();
	}, [context, data.petition, openShareVisualModal]);

	return triggerShareVisualModal;
}
